import * as React from "react";
import type { SVGProps } from "react";
const SvgFollowersIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="followers_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M256 234.667a106.667 106.667 0 1 1 213.333 0 106.667 106.667 0 0 1-213.333 0zm106.667-192a192 192 0 1 0 0 384 192 192 0 0 0 0-384zm362.666 362.666a64 64 0 1 1 128 0 64 64 0 0 1-128 0zm64-149.333a149.333 149.333 0 1 0 0 298.667 149.333 149.333 0 0 0 0-298.667zM128 789.333a234.667 234.667 0 1 1 469.333 0V896a42.667 42.667 0 1 0 85.334 0V789.333a106.667 106.667 0 0 1 213.333 0V896a42.667 42.667 0 1 0 85.333 0V789.333a192 192 0 0 0-328.49-135.04 320 320 0 0 0-610.176 135.04V896A42.667 42.667 0 1 0 128 896V789.333z"
    />
  </svg>
);
export default SvgFollowersIcon;
